// ✏️  Edita los textos entre comillas
// ➕  Para agregar una opción, copia un bloque { } y pégalo
// ⚠️  No elimines llaves { }, corchetes [ ] ni comas ,

export const CONTABILIDAD = {
  mensaje: '¿Qué necesitas en Contabilidad?',
  opciones: [
    {
      boton: 'Asiento contable',
      respuesta: 'Los asientos se registran en Contabilidad → Mantener asiento. Puedes crear asientos manuales o revisarlos.',
    },
    {
      boton: 'Cierre contable',
      respuesta: 'El cierre contable se realiza en Contabilidad → Cierre. Asegúrate de que todos los asientos del período estén confirmados antes de cerrar.',
    },
    {
      boton: 'Balance general',
      respuesta: 'El balance general está en Contabilidad → Reportes → Balance general. Filtra por período y empresa.',
    },
  ],
}
